import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RadioState } from '@app/core/states/radio.state';
import { SavedToSessionstorage } from '@app/shared/constants';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select } from '@ngxs/store';
import { ToasterService } from '@radioking/shared/common-services';
import {
  PanelContainerInput,
  PanelRegistryService,
  PANELS_KEYS,
} from '@radioking/shared/pannel-manager';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

import { SchedulerAllTracksRequest } from '../../../../../scheduler-core/src/lib/states/scheduler-core.actions';
import { programsToasts } from '../../programs.toast';
import { CreateProgramComponent } from '../sides/create-program/create-program.component';
import { EditProgramComponent } from '../sides/edit-program/edit-program.component';
import { MobProgramDetailsComponent } from '../sides/mob-program-details/mob-program-details.component';

@Component({
  selector: 'rk-programs-shell',
  templateUrl: './programs-shell.component.html',
  styleUrls: ['./programs-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramsShellComponent implements OnInit, OnDestroy {
  sides: PanelContainerInput[] = [
    {
      key: PANELS_KEYS.CREATE_PROGRAM,
      val: CreateProgramComponent,
    },
    {
      key: PANELS_KEYS.EDIT_PROGRAM,
      val: EditProgramComponent,
    },
    {
      key: PANELS_KEYS.PROGRAM_DETAILS,
      val: MobProgramDetailsComponent,
    },
  ];

  @Select(RadioState.currentRadioId)
  radioId$: Observable<number>;

  subscription = new Subscription();

  constructor(
    private readonly panelRegistry: PanelRegistryService,
    private readonly componentFactory: ComponentFactoryResolver,
    private readonly toaster: ToasterService,
  ) {
    this.panelRegistry.registerMultiplePanels(this.sides, this.componentFactory);
    this.toaster.registerToasts(programsToasts);
  }

  ngOnInit() {
    this.subscription.add(
      this.radioId$
        .pipe(
          filter(id => !!id),
          distinctUntilChanged(),
        )
        .subscribe(id => {
          this.getTracks(id);
        }),
    );
  }

  @Dispatch()
  getTracks(id: number) {
    return new SchedulerAllTracksRequest(id);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.panelRegistry.unregisterMultiplePanels(this.sides);
    sessionStorage.removeItem(SavedToSessionstorage.MEMORIZED_SEARCH_PROGRAMS);
  }
}
